var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isOpen)?_c('v-dialog',{attrs:{"value":_vm.isOpen,"max-width":"600"},on:{"input":_vm.close}},[_c('v-card',{staticClass:"iframe-wrapper"},[_c('iframe',{ref:"iframe",attrs:{"scrolling":"no","frameBorder":"0","height":"700","src":_vm.iframeSrc}})])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }